import axios from 'axios'
import { Component, ComponentChild } from 'preact'
import ImageUploader from '../../control-components/category/ImageUploader'
import Panel from '../../control-components/panel'
import InputGroup from '../../control-components/ui-components/InputGroup'
import { HeroImage } from '../image-uploading/HeroImage'

interface ChangePayload {
  hero_image: string
  headline: string
}

interface Props {
  onChange: (state: ChangePayload) => void
  heroImage: string
  headline: string
}

interface State {
  src: null | string
  crop: {
    x: number
    y: number
    width: number
    height: number
    aspect: number
  }
  pixelCrop: {
    width: number
    height: number
    x: number
    y: number
  }
  errorMessage: null | string
  hero_image: string
  headline: string
}

export class Hero extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      src: null,
      crop: {
        x: 0,
        y: 0,
        width: 96,
        height: 16,
        aspect: 6
      },
      pixelCrop: {
        width: 96,
        height: 16,
        x: 0,
        y: 0
      },
      errorMessage: null,
      hero_image: props.heroImage,
      headline: props.headline
    }
    this.uploader = null

    this.saveImage = this.saveImage.bind(this)
    this.cancelUpload = this.cancelUpload.bind(this)
  }

  uploader: HTMLInputElement | null

  async saveImage() {
    try {
      const element: HTMLInputElement | null = document.querySelector('input#csrftoken')

      let csrf: string = ''
      if (element !== null) {
        csrf = element.value
      }

      const formData = new FormData()
      if (this.uploader === null) {
        return
      }
      if (this.uploader.files === null) {
        return
      }
      const file = this.uploader.files[0]

      formData.append('image', file)
      formData.append('yip_csrf_token', csrf)
      formData.append('crop_coords[x]', Math.round(this.state.pixelCrop.x).toString())
      formData.append('crop_coords[y]', Math.round(this.state.pixelCrop.y).toString())
      formData.append('crop_coords[width]', Math.round(this.state.pixelCrop.width).toString())
      formData.append('crop_coords[height]', Math.round(this.state.pixelCrop.height).toString())

      const res = await axios.post('/attachment/new', formData)
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const { source_thumb } = res.data
      this.setState({ hero_image: source_thumb, src: null })
    } catch (e) {
      console.log(e)
    }
  }

  cancelUpload() {
    this.setState({ src: null })
    if (this.uploader) {
      this.uploader.value = ''
    }
  }

  componentWillUpdate(nextProps: Props, nextState: State) {
    if (nextProps.onChange && this.state !== nextState) {
      nextProps.onChange({ hero_image: nextState.hero_image, headline: nextState.headline })
    }
  }

  render() {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { headline, hero_image } = this.state
    const isForum = window.inSidedData?.communityId

    return (
      <div className='hero-banner-wrapper'>
        <InputGroup
          title='Headline'
          name='headline'
          placeholder='Add a headline'
          type='text'
          onChange={(event) => {
            return this.setState({ headline: event.target.value })
          }}
          value={headline}
        />
        <label>Hero image</label>
        <p>
          Maximum file size: 5m. Allowed image types: .jpg, .png, .gif. We recommend a minimum of
          2880*480px
        </p>
        <HeroImage
          src={hero_image}
          dimentionLabel='2880px × 480px'
          onEdit={() => this.uploader?.click()}
          onRemove={() => this.setState({ hero_image: '' })}
          onUpload={() => this.uploader?.click()}
          buttonClassName={!isForum && 'btn-default'}
          uploadButtonClassName={!isForum && 'btn-default btn-primary'}
        />

        <ImageUploader
          width={2880}
          height={480}
          // eslint-disable-next-line @typescript-eslint/naming-convention
          onUploaded={({ source_thumb }) => {
            return this.setState({ hero_image: source_thumb })
          }}
          uploaderRef={(ref) => {
            this.uploader = ref
          }}
        />
      </div>
    )
  }
}

interface PanelProps extends Props {
  switcher?: ComponentChild
  dragHandle: ComponentChild
}

const HeroPanel = (props: PanelProps) => {
  return (
    <Panel
      collapsible
      customClass='homepage-widget'
      title={
        <div className='panel-title-with-switch'>
          <div className='homepage-reorderable-panel-title'>
            {props.dragHandle}
            <span>Search Banner</span>
          </div>
          {props.switcher}
        </div>
      }
    >
      <Hero {...props} />
    </Panel>
  )
}

export default HeroPanel
